import http from "../services/httpService";

export async function getWorkbooks() {
    const resp = await http.get(`/workbooks/`);
    return resp.data;
}
export async function getWorkbook(workbookId) {
    const resp = await http.get(`/workbooks/${workbookId}/`);
    return resp.data;
}

export async function getWorkbookQuestions(workbookId) {
    const resp = await http.get(`/questions/?workbook=${workbookId}`);
    return resp.data;
}

export async function saveAnswer(data) {
    if (data.id) {
        const resp = await http.patch(`/answers/${data.id}/`, data);
        return resp.data;
    } else {
        const resp = await http.post(`/answers/`, data);
        return resp.data;
    }
}

export async function checkAnswerWithAI(data) {
    const resp = await http.post(`/answers/check/`, data);
    return resp.data;
}

export async function updateAiResponse(aiResponseId, data) {
    const resp = await http.patch(`/ai_responses/${aiResponseId}/`, data);
    return resp.data;
}
